// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationListMetaQuery } from './AutomationListMetaQuery';
import {
    AutomationListMetaQueryFromJSON,
    AutomationListMetaQueryFromJSONTyped,
    AutomationListMetaQueryToJSON,
    AutomationListMetaQueryToJSONTyped,
} from './AutomationListMetaQuery';

/**
 * 
 * @export
 * @interface AutomationListMeta
 */
export interface AutomationListMeta {
    /**
     * Total number of items
     */
    total?: number;
    /**
     * Current page number
     */
    page?: number;
    /**
     * Items per page
     */
    perPage?: number;
    /**
     * 
     */
    query?: AutomationListMetaQuery;
}

/**
 * Check if a given object implements the AutomationListMeta interface.
 */
export function instanceOfAutomationListMeta(value: object): value is AutomationListMeta {
    return true;
}

export function AutomationListMetaFromJSON(json: any): AutomationListMeta {
    return AutomationListMetaFromJSONTyped(json, false);
}

export function AutomationListMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationListMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'perPage': json['perPage'] == null ? undefined : json['perPage'],
        'query': json['query'] == null ? undefined : AutomationListMetaQueryFromJSON(json['query']),
    };
}

export function AutomationListMetaToJSON(json: any): AutomationListMeta {
    return AutomationListMetaToJSONTyped(json, false);
}

export function AutomationListMetaToJSONTyped(value?: AutomationListMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'page': value['page'],
        'perPage': value['perPage'],
        'query': AutomationListMetaQueryToJSON(value['query']),
    };
}

